import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/syep14.png";
import Tilt from "react-parallax-tilt";


import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";


function Impact2() {

  const navigate = useNavigate(); // Initialize navigate

  const handleClick = () => {
    navigate("/registration#internship-section"); // This will navigate to the "/another-page" route
  };




    const videoId = "5mPU-mIQgoQ"; 
return (
    <Container fluid className="home-about-section" id="about">
    <Container>
        <Row>
        <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
            INTERNSHIPS AT <span className="purple"> CHOICEST FRUIT </span> 
            </h1>
            <p className="home-about-body">
                        At Choicest Fruit<span className="small-r-symbol">®</span>, we believe the future of technology must be ethical, inclusive, 
                        accessible, affordable and community-driven. That’s why we created our internship program, giving young people 
                        real-world experience in Responsible Technology Development while cultivating leadership, 
                        creativity, and a sense of service.
                        <br />
                        <br />
                        <h2>A Partnership for Youth Opportunity</h2>
                         For the past two years, Choicest Fruit has partnered with Travis County and the
                         City of Austin through the Work-Based Learning / Summer Youth Employment Program.
                         Together, we’ve hosted 7-week internship programs that equip high school and 
                         college students with valuable career exposure, hands-on training, and meaningful
                         work experience in the growing field of ethical tech.           
                        <br />
                        In addition, Choicest Fruit partners with overseas organizations and companies that 
                        serve young people, offering their youth the opportunity to intern with us. These global
                        collaborations enrich the program by bringing together diverse perspectives and
                        experiences, creating a learning environment where young people from different parts
                        of the world can grow, collaborate, and innovate side by side.
                        <br />
                         <br />
                        <h2>What Interns Experience</h2>
                        Our interns don’t just learn and create technology, they actively solve real community problems using tech and help train others to do the same.

                         <li><span className="purple">Ethical Tech Design:</span> Applying design thinking and critical reflection to ensure technology serves humanity.</li>
                         <li><span className="purple">Hands-On Development:</span> Building EdTech apps and ethical tools using in-demand web technologies.</li>
                         <li><span className="purple">Collaborative Projects:</span> Working remotely and on-site with peers to solve real-world problems.</li>
                         <li><span className="purple">Career Readiness:</span> Gaining technical skills, teamwork experience, and exposure to pathways in STEM and social impact.</li>
                          <br />
                          Interns progress through different stages of their educational journeys while developing their intellectual, creative, and moral capacities. 
                          They are encouraged to identify the tech needs of their own communities and design solutions with a spirit of purpose and service.
                          <br />
                          <br />
                          <h2>Impact Beyond the Internship</h2> 
                           Our internship is more than a summer job, it’s a stepping stone toward leadership and long-term contribution. Many participants go on to:

                          <li><span className="purple">Mentor peers as Choicest Fruit Ambassadors</span></li>

                          <li><span className="purple">Continue developing community-focused projects</span></li>

                          <li><span className="purple">Apply their skills in higher education and future careers</span></li>
                        <br />
                         By empowering youth to think critically and ethically about technology, we’re cultivating the next generation of innovators who will shape a more inclusive and responsible digital world.
                           <br />
          </p>
          <Button onClick={handleClick}>Apply Here</Button>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>SUMMER INTERNSHIP PROGRAM</h1>
          <Container>    
        {/* Responsive Video */}
        <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', maxWidth: '100%', marginBottom: '20px' }}>
                                <iframe
                                    title="YouTube video"
                                    src={`https://www.youtube.com/embed/${videoId}`}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                    }}
                                />
      </div>
    </Container>
           
          </Col>
            </Row>

            
                <Col md={12} className="home-testimonial">
                <h1>TESTIMONIALS</h1>
                </Col>
          
            


      </Container>
    </Container>
  );
}
export default Impact2;
